const resourceTypeToResourcePrefix = (resourceType) => {
  const typeFragments = resourceType.split('.');
  typeFragments.shift();
  return typeFragments.join('.');
};

export const buildResourceId = (resourceType, id) => {
  return `${resourceTypeToResourcePrefix(resourceType)}:${id}`;
};
